import styled from 'styled-components';

import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { desktopAndAbove, laptopAndAbove } from '#src/style/mediaQuery.ts';

export const SearchLayoutRoot = styled.div`
  padding: 0 var(--double-unit);
  min-height: inherit;
  position: relative;
  @media ${laptopAndAbove} {
    padding: 0 var(--triple-unit) 0 var(--double-unit);
  }
`;

export const SearchLayoutContainer = styled.div`
  display: flex;
  gap: var(--unit);
  align-items: stretch;
  height: 100%;
  min-width: 100%;
  & > * {
    max-width: 100%;
  }
`;

export const SearchLayoutMain = styled(Vertical).attrs({ gap: 2 })`
  padding: var(--double-unit) 0;
  flex: 1;
  @media ${desktopAndAbove} {
    padding-top: var(--triple-unit);
  }
`;

export const LeftFilters = styled.aside`
  padding: var(--triple-unit) 0;
  isolation: isolate;
  overflow: hidden;
  height: max-content;
  flex: none;
  width: 300px;
  max-width: 100%;
`;

export const VerticalScroll = styled.div`
  overflow: auto;
  flex-shrink: 0;
  height: 100%;
  position: sticky;
  top: var(--current-stack-height);
  max-height: calc(var(--100vh) - var(--current-stack-height));
  scrollbar-gutter: stable both-edges;
  padding-right: var(--unit);
`;
